import * as React from "react";
import { NavLink, Redirect } from "react-router-dom";
import { withTranslation } from "react-i18next";
import CoreComponent from "./CoreComponent";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { IObject, IHolder } from "../interfaces";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { arrayToFormData } from "../utils/functions";

const CancelToken = Axios.CancelToken;
let cancel: any;

interface IState {
    objects: IObject[];
    limit: number;
    pagination: any;
    ids: number[];
    type: string;
    sort: string;
    isLoading: boolean;
    isOpen: boolean;
    currentPage: number;
    unsorted_count: number;
    error_count: number;
    tab: string;
}

class NoSorted extends CoreComponent<any, any> {
    state: IState = {
        objects: [],
        limit: 30,
        pagination: null,
        ids: [],
        type: "",
        sort: "",
        tab: "nosorted",
        isLoading: true,
        isOpen: false,
        unsorted_count: null,
        error_count: null,
        currentPage: 1,
    };

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
    }

    componentDidMount() {
        let _this = this;

        $(".datepicker")
            .datepicker({
                startView: 1,
                minViewMode: 1,
                language: "ru",
                format: "yyyy-mm",
            })
            .on("changeDate", function (e: any) {
                if (e.target.name == "date_from")
                    _this.setState(
                        {
                            date_from: e.target.value,
                        },
                        () => {
                            _this.loadObjects();
                        }
                    );
                else
                    _this.setState(
                        {
                            to_date: e.target.value,
                        },
                        () => {
                            _this.loadObjects();
                        }
                    );
            });

        $(".operator").select2();
    }

    async componentWillMount() {
        this.loadObjects();
    }

    async loadObjects(search: string = null) {
        cancel && cancel();

        this.setState(
            {
                isLoading: true,
            },
            async () => {
                let url = null;
                let limit = this.state.limit * this.state.currentPage;

                url = `${config.api}/composition/no-sorted?limit=${limit}&tab=${this.state.tab}`;

                if (this.state.sort) {
                    url += `&sort=${this.state.sort}`;
                }

                if (this.state.type) {
                    url += `&type=${this.state.type}`;
                }

                if (search) {
                    url += `&search=${search}`;
                }

                let res = await Axios.get(url, {
                    cancelToken: new CancelToken(function executor(c) {
                        cancel = c;
                    })
                });

                if (!this.isUnmounted) {
                    this.setState({
                        objects: res.data.models,
                        pagination: res.data.pagination,
                        type: res.data.type,
                        sort: res.data.sort,
                        unsorted_count: res.data.unsorted_count,
                        error_count: res.data.error_count,
                        isLoading: false,
                    });
                }
            }
        );
    }

    setOrder(sort: string) {
        this.setState(
            {
                type:
                    this.state.sort != sort
                        ? "asc"
                        : this.state.type == "asc"
                            ? "desc"
                            : "asc",
                sort,
            },
            () => {
                this.loadObjects();
            }
        );
    }

    showMore() {
        this.setState(
            {
                currentPage: this.state.currentPage + 1,
            },
            () => {
                this.loadObjects();
            }
        );
    }

    async delete() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/composition/delete`,
                    arrayToFormData({ ids: this.state.ids })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        objects: this.state.objects.filter(
                            (object: IObject) =>
                                !response.data.includes(object.id.toString())
                        ),
                        ids: [],
                    });

                toast("Объекты удалены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите объектов", { type: "error" });
            }
        }
    }

    async move() {
        if (confirm("Вы уверены?")) {
            if (this.state.ids.length > 0) {
                let response: AxiosResponse = await Axios.post(
                    `${config.api}/composition/move`,
                    arrayToFormData({ ids: this.state.ids })
                );

                if (response.data && response.data.length > 0)
                    this.setState({
                        objects: this.state.objects.filter(
                            (object: IObject) =>
                                !response.data.includes(object.id.toString())
                        ),
                        ids: [],
                    });

                toast("Объекты перемещены: " + response.data.length, {
                    type: "success",
                });
            } else {
                toast("Выберите объектов", { type: "error" });
            }
        }
    }

    update() {
        if (this.state.ids.length > 0) {
            this.props.history.push('/admin/object/update/' + this.state.ids.join(","));
        } else {
            toast("Выберите объектов", { type: "error" });
        }
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    componentWillReceiveProps(nextProps: any) {
        let { search } = nextProps;

        this.loadObjects(search);
    }


    render() {
        let { t, auth } = this.props;

        if (!auth.isAuthentificated) return <Redirect to="/login" />;

        return (
            <div>
                <div className="crm-holders no-sorted">
                    <div className="wrapper" style={{ maxWidth: "1370px" }}>
                        <NavLink className="crm-holders__back" to="/admin">
                            Назад
                        </NavLink>
                        <span className="crm-holders__title">
                            Несортированные
                        </span>

                        <div className="crm-holders__headline">
                            <div className="tabs">
                                <div className="tabs-header">
                                    <div style={{ display: "flex" }}>
                                        <div
                                            className={
                                                "tabs-header__item " +
                                                (this.state.tab == "nosorted"
                                                    ? "border-line"
                                                    : "")
                                            }
                                            data-tab="1"
                                            style={{
                                                display: "flex",
                                                marginRight: "25px",
                                            }}
                                            onClick={() => {
                                                this.setState(
                                                    {
                                                        tab: "nosorted",
                                                    },
                                                    () => {
                                                        this.loadObjects();
                                                    }
                                                );
                                            }}
                                        >
                                            В несортированные{" "}
                                            <span className="crm-count">
                                                {this.state.unsorted_count}
                                            </span>{" "}
                                        </div>
                                        <div
                                            className={
                                                "tabs-header__item " +
                                                (this.state.tab == "error"
                                                    ? "border-line"
                                                    : "")
                                            }
                                            data-tab="2"
                                            style={{ display: "flex" }}
                                            onClick={() => {
                                                this.setState(
                                                    {
                                                        tab: "error",
                                                    },
                                                    () => {
                                                        this.loadObjects();
                                                    }
                                                );
                                            }}
                                        >
                                            Ошибки{" "}
                                            <span className="crm-count">
                                                {this.state.error_count}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ display: "flex" }}>
                                <a
                                    className="crm-button mr-3"
                                    role="button"
                                    onClick={() => {
                                        this.update();
                                    }}
                                >
                                    Изменить
                                </a>
                                <NavLink
                                    to="/admin/object"
                                    className="crm-button mr-3"
                                    role="button"
                                >
                                    Добавить
                                </NavLink>
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.move();
                                    }}
                                    style={{ margin: "0", marginRight: "15px", width: "120px" }}
                                    className="btn-del"
                                >
                                    В чёрный список
                                </a>
                                <a
                                    role="button"
                                    onClick={() => {
                                        this.delete();
                                    }}
                                    style={{ margin: "0", marginRight: "15px" }}
                                    className="btn-del"
                                >
                                    Удалить
                                </a>
                            </div>
                        </div>

                        <div className="crm-list">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <input
                                                type="checkbox"
                                                onChange={() => {
                                                    if (
                                                        this.state.ids.length !=
                                                        this.state.objects
                                                            .length
                                                    ) {
                                                        this.setState({
                                                            ids: this.state.objects.map(
                                                                (
                                                                    holder: IObject
                                                                ) => holder.id
                                                            ),
                                                        });
                                                    } else {
                                                        this.setState({
                                                            ids: [],
                                                        });
                                                    }
                                                }}
                                                checked={
                                                    this.state.ids.length ==
                                                    this.state.objects.length
                                                }
                                            />
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("id");
                                                }}
                                            >
                                                ID
                                            </a>
                                        </th>

                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("name");
                                                }}
                                            >
                                                Название
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>

                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("views");
                                                }}
                                            >
                                                Кол-во <br /> просмотров
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>

                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("created_at");
                                                }}
                                            >
                                                Дата
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("place");
                                                }}
                                            >
                                                Площадка
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("currency");
                                                }}
                                            >
                                                Доход{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <a
                                                role="button"
                                                onClick={() => {
                                                    this.setOrder("youtube_id");
                                                }}
                                            >
                                                Source ID{" "}
                                                <img
                                                    src="img/Group 199.svg"
                                                    alt=""
                                                />
                                            </a>
                                        </th>
                                        <th>
                                            <img
                                                src="img/crm-youtube.svg"
                                                alt=""
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!this.state.isLoading &&
                                        this.state.objects.length == 0 && (
                                            <tr>
                                                <td colSpan={11}>
                                                    {t("Ничего не найдено")}
                                                </td>
                                            </tr>
                                        )}
                                    {this.state.isLoading && (
                                        <tr>
                                            <td colSpan={11}>
                                                {t("Загрузка данных")}
                                            </td>
                                        </tr>
                                    )}
                                    {this.state.objects.map(
                                        (object: IObject, i: number) => {
                                            return (
                                                <tr key={i}>
                                                    <td>
                                                        <input
                                                            type="checkbox"
                                                            checked={
                                                                !!this.state.ids.find(
                                                                    (
                                                                        id: number
                                                                    ) =>
                                                                        id ==
                                                                        object.id
                                                                )
                                                            }
                                                            onClick={(e: any) => {
                                                                let lastIndex = this.state.objects.findIndex((object: IObject) => object.id == this.state.ids[this.state.ids.length - 1]);

                                                                if (
                                                                    e.target.checked
                                                                ) {
                                                                    if (e.shiftKey && lastIndex > -1) {
                                                                        this.setState({
                                                                            ids: [
                                                                                ...this.state.ids,
                                                                                ...this.state.objects.filter((object: IObject, ii: number) => lastIndex < i ? ii >= lastIndex && ii <= i : ii >= i && ii <= lastIndex).map((object: IObject) => object.id)
                                                                            ]
                                                                        })
                                                                    } else {
                                                                        this.setState({
                                                                            ids: [
                                                                                ...this
                                                                                    .state
                                                                                    .ids,
                                                                                object.id,
                                                                            ],
                                                                        });
                                                                    }
                                                                } else {
                                                                    this.setState({
                                                                        ids: this.state.ids.filter(
                                                                            (
                                                                                id: number
                                                                            ) =>
                                                                                id !=
                                                                                object.id
                                                                        ),
                                                                    });
                                                                }
                                                            }}
                                                            onChange={(e: any) => {

                                                            }}
                                                        />
                                                    </td>
                                                    <td>{object.id}</td>

                                                    <td>
                                                        <div className="d-flex justify-content-center">
                                                            <NavLink
                                                                to={
                                                                    "/admin/object/" +
                                                                    object.id
                                                                }
                                                                className="mr-2">
                                                                {object.name}
                                                            </NavLink>
                                                            <NavLink to={"/admin/object/report/" + object.id}> <i className="fa fa-bars fs-14"></i> </NavLink>
                                                        </div>
                                                    </td>
                                                    <td>{object.views}</td>
                                                    <td>{object.created_at}</td>
                                                    <td>{object.place}</td>
                                                    <td className="text-green">
                                                        $ {Number.parseFloat(
                                                            object.doxod.toString()
                                                        ).toFixed(3).slice(0, -1)}
                                                    </td>
                                                    <td>{object.youtube_id}</td>
                                                    <td>
                                                        {object.place == "YouTube" && <a href={"https://youtu.be/" + object.youtube_id} target="_blink">
                                                            <img src="img/crm-youtube.svg" alt="" />
                                                        </a>}
                                                        {object.place != "YouTube" && object.youtube_id.startsWith("103") && <img src="img/ico1.svg" width="15" alt="" />}
                                                        {object.place != "YouTube" && object.youtube_id.startsWith("A") && <img src="img/ico2.svg" width="15" alt="" />}
                                                    </td>
                                                </tr>
                                            );
                                        }
                                    )}
                                </tbody>
                            </table>
                            <div className="text-center p-3">
                                {this.state.objects.length > 0 && this.state.objects.length < this.state.pagination?.totalCount && (
                                    <a
                                        role="button"
                                        className="spec-color fs-12"
                                        onClick={() => {
                                            this.showMore();
                                        }}
                                    >
                                        Показать ещё...
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(function (state: any) {
    return {
        auth: state.auth,
        search: state.search,
    };
})(withTranslation()(NoSorted));
